<form (ngSubmit)="onSubmit()">
  <div class="lg:grid lg:grid-cols-4 lg:gap-x-3">
    <lib-address-lookup-form-field
      class="w-full lg:col-span-3"
      [containerClasses]="'lg:grid lg:grid-cols-3 lg:gap-x-3'"
      [addressPrefill]="addressPrefill"
      [addressLookupFields]="addressLookupFields"
      [disableInputFields]="lineCheckResultsShown() || lineCheckResultsLoading()"
      (postCodeValue)="getPostCodeValue($event)"
      (cityValue)="getCityValue($event)"
      (streetValue)="getStreetValue($event)"
      (streetNumberValue)="getStreetNumberValue($event)"
      ngSkipHydration
    ></lib-address-lookup-form-field>
    <div class="lg:col-span-1 pb-4">
      <lib-button-form-field
        #submitButton
        data-testid="submit-linecheck-button"
        class="block"
        size="full-width"
        [disabled]="
          lineCheckResultsShown() ||
          lineCheckResultsLoading() ||
          !(postCode && streetName && (streetNumber || streetNumber === ''))
        "
        [loading]="lineCheckResultsLoading()"
      >
        {{ buttonText }}
      </lib-button-form-field>

      @if (lineCheckResultsShown()) {
        <div class="mt-6 text-center">
          <span class="underline cursor-pointer font-extrabold p-2" (click)="onReset()">
            {{ backButtonText }}
          </span>
        </div>
      }
    </div>
  </div>
</form>
